export default {
    overview: {
        loading: false,
        error: false,
        noContent: false,
        year: undefined,
        years: undefined,
        items: undefined,
        page: 1,
        limits: [5,10,20,50],
        limit: 10,
        show: 'mine',
        showList: ['mine', 'all'],
        filter: '',
        search: '',
        filters: [
            'initiated',
            'readyForBackOffice',
            'readyForContractManager',
            'readyForSupplier',
            'completed'
        ]
    },
    contract: {
        loading: false,
        error: false,
        noContent: false,
        item: undefined,
        part: 'supplierInfo',
        email: {
            loading: false,
            error: false
        },
        notes: {
            loading: false,
            error: false,
            noContent: false,
            item: undefined
        },
        note: {
            loading: false,
            error: false,
            item: {
                internal: 0,
                field: 1,
                note: ""
            }
        },
        finish: {
            loading: false,
            error: false,
            noContent: false
        },
        download: {
            loading: false,
            error: false
        },
        progress: {
            loading: false,
            error: false,
            noContent: false,
            accept: {
                loading: false,
                error: false
            },
            item: {
                supplierInfo: false,
                sites: false,
                accommodations: false,
                prices: false,
                extras: false,
                arrivalRules: false,
                cancellationRules: false,
                discounts: false,
                allocations: false,
                terms: false,
            }
        },
        form: {
            loading: false,
            error: false,
            item: {
                sites: {
                    id: undefined,
                    field: 1,
                    note: undefined,
                    accepted: false,
                },
                accommodations: {
                    id: undefined,
                    field: 2,
                    note: undefined,
                    accepted: false,
                },
                prices: {
                    id: undefined,
                    field: 3,
                    note: undefined,
                    accepted: false,
                },
                extras: {
                    id: undefined,
                    field: 4,
                    note: undefined,
                    accepted: false,
                },
                arrivalRules: {
                    id: undefined,
                    field: 5,
                    note: undefined,
                    accepted: false,
                },
                discounts: {
                    id: undefined,
                    field: 6,
                    note: undefined,
                    accepted: false,
                },
                allocations: {
                    id: undefined,
                    field: 7,
                    note: undefined,
                    accepted: false,
                },
                terms: {
                    id: undefined,
                    field: 8,
                    note: undefined,
                    accepted: false,
                },
                supplierInfo: {
                    id: undefined,
                    field: 9,
                    note: undefined,
                    accepted: false,
                },
                cancellationRules: {
                    id: undefined,
                    field: 10,
                    note: undefined,
                    accepted: false,
                },
            }
        }
    },
    history: {
        loading: false,
        error: false,
        noContent: false,
        items: undefined
    },
    contractManagement: {
        loading: false,
        error: false,
        noContent: false,
        item: undefined,
        supplier: {
            loading: false,
            error: false,
            noContent: false,
            items: {
                siteInfo: [],
                accInfo: []
            }
        },
        progress: {
            basic: {
                priceExtra: false,
                allotmentRules: false,
                arrivalRules: false,
                commission: false,
                discounts: false,
                notes: false,
            },
            extended: {
                siteInfo: false,
                accInfo: false,
                arrivalDeparture: false,
                brands: false,
            }
        },
        form: {
            loading: false,
            error: false,
            noContent: false,
            part: 'basic',
            subPart: 'priceExtra',
            index: 0,
            defaults: {
                basic: {
                    text: undefined,
                    files: [],
                    s3: []
                },
                extended: {
                    accInfo: {
                        entityId: undefined,
                        name: undefined,
                        id: undefined,
                        text: undefined,
                        files: [],
                        images: [],
                        s3: [],
                        imagesS3: [],
                        sites: []
                    },
                    siteInfo: {
                        showInContract: true,
                        entityId: undefined,
                        name: undefined,
                        id: undefined,
                        text:undefined,
                        area: undefined,
                        files: [],
                        images: [],
                        s3: [],
                        imagesS3: [],
                    },
                    arrivalDeparture: {
                        text: undefined,
                        files: [],
                        s3: []
                    },
                    brands: {
                        brands: [],
                    }
                }
            },
            basic: undefined,
            extended: undefined
        },
        brands: {
            brands: [],
            noContent: false,
            error: false,
            loading: false,
        },
    },
    draft: {
        loading: false,
        error: false,
        item: null,
    },
    file: {
        loading: false,
        error: false,
        noContent: false
    },
    tips: [
        {
            title: 'tips.contractManagementPage.progress.title',
            body: 'tips.contractManagementPage.progress.body'
        },
        {
            title: 'tips.contractManagementPage.upload.title',
            body: 'tips.contractManagementPage.upload.body'
        },
        {
            title: 'tips.contractManagementPage.expand.title',
            body: 'tips.contractManagementPage.expand.body'
        },
        {
            title: 'tips.contractManagementPage.indicator.title',
            body: 'tips.contractManagementPage.indicator.body'
        }
    ]
}



// WEBPACK FOOTER //
// ./src/store/modules/contract/state.js